import { NewsLayout } from "@features/layout/news";

export const NewsPage = () => {
  return <NewsLayout />;
};
